const { ActionTypes } = require("../constants/action_types");

const initialState = 0;

export const activeCandidateTabs = (state = initialState, { type, tabs }) => {

    switch (type) {
        case ActionTypes.TENANT_ADMIN_CANDIDATE_TAB:
            return tabs;
        default:
            return state;
    }
};
